/* eslint-disable */
require('./agricultura')
require('./educacion')
require('./identidad')
require('./pagos')
require('./tramite')
